<div *ngIf="isLoading">
  <div id="preloader">
    <div id="loader" class="loader">
      <div class="loader-container">
        <div class="loader-icon">
          <img
            src="favicon.ico"
            style="width: auto"
            alt="Preloader"
          />
        </div>
      </div>
    </div>
  </div>
</div>
